import React from 'react';

/**
 * HearClear brand logo — uses the real wordmark image from /brand/hearclear-logo.png
 * variant: "full" = wordmark on transparent, "mono" = navy mark only, "compact" = icon only
 */
export function BrandLogo({ height = 28, className = '' }) {
  const src = '/brand/hearclear-logo.png';
  return (
    <img
      src={src}
      alt="HearClear"
      style={{ height, width: 'auto', objectFit: 'contain' }}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
}

export function BrandBadge({ size = 32, className = '' }) {
  return (
    <div
      className={`rounded-md flex items-center justify-center ${className}`}
      style={{
        width: size, height: size,
        background: 'linear-gradient(135deg, #2D3982 0%, #4C5AB5 100%)',
      }}
    >
      {/* stylised ear glyph in white */}
      <svg viewBox="0 0 24 24" width={size * 0.55} height={size * 0.55} fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3a6 6 0 0 0-6 6c0 3 2 4 2 7a3 3 0 0 0 3 3c1 0 2-1 2-2s1-2 2-2 3-1 3-3-1-3-2-4a6 6 0 0 0-4-5Z" />
        <path d="M12 8a2 2 0 0 1 2 2" />
      </svg>
    </div>
  );
}
